import { Route, Routes } from 'react-router-dom';
import { ChatSession, SessionList } from './components';

export const AgentChat = () => {
  return (
    <Routes>
      <Route path="/" element={<SessionList />} />
      <Route path="/:sessionId" element={<ChatSession />} />
    </Routes>
  );
};
